// Generated by BUCKLESCRIPT VERSION 3.0.0, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";

function handleDomFormChange(handleChange, $$event) {
  return Curry._1(handleChange, $$event.target.value);
}

function handleDomFormSubmit(handleSubmit, $$event) {
  $$event.preventDefault();
  return Curry._1(handleSubmit, /* () */0);
}

export {
  handleDomFormChange ,
  handleDomFormSubmit ,
  
}
/* No side effect */
